import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Gte = ({ property, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'GTE')
  
  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default Gte
